<template>
  <crud
    mode="ServerSide"
    :resolverType="resolverType"
    :list="list"
    :get="get"
    :create="create"
    :update="update"
    :remove="remove"
    :page-title="pageTitle"
    :fields-info="fieldsInfo"
    :details-title="$t('detailsTitle')"
    delete-mode="hard"
  >
  </crud>
</template>

<script>
// import Crud from '@/utils/crud/components/Crud.vue'
import Crud from '@/utils/crud/components/Crud.vue'

export default {
  data () {
    return {
      resolverType: 'dynamodb',
      list: 'listUserPermissions',
      get: 'getUserPermission',
      create: 'createUserPermission',
      update: 'updateUserPermission',
      remove: 'deleteUserPermission',
      // api: 'omsag-tools-api',
      // prefix: 'crud/admin',
      // path: 'user-permissions',
      // paths: {
      //   i: 'admin/user-permissions',
      // },
      pageTitle: 'admin.userPermissions',
    }
  },
  computed: {
    fieldsInfo () {
      return [
        {
          text: this.$t('fields.id'),
          name: 'id',
          details: false,
        },
        {
          type: 'select',
          url: 'crud/admin/users',
          query: 'listUsers',
          list: {
            value: 'id',
            text: 'user',
            data: [],
          },
          column: 'userID',
          text: this.$t('fields.user'),
          name: 'user',
          apiObject: {
            name: 'user.name',
          },
        },
        {
          text: this.$t('fields.userEmail'),
          name: 'userEmail',
          apiObject: {
            name: 'user.email',
          },
          details: false,
        },
        {
          type: 'select',
          url: 'crud/admin/permissions',
          query: 'listPermissions',
          list: {
            value: 'id',
            text: 'name',
            data: [],
          },
          column: 'permissionID',
          text: this.$t('fields.permission'),
          name: 'permission',
          apiObject: {
            name: 'permission.name',
          },
        },
      ]
    },
  },
  components: {
    Crud,
  },
  i18n: {
    messages: {
      de: {
        detailsTitle: 'Benutzer - Rechte',
        fields: {
          id: 'Id',
          user: 'Benutzer',
          userEmail: 'E-Mail',
          permission: 'Recht',
          permissionCode: 'Code',
        },
      },
      en: {
        detailsTitle: 'User - permission',
        fields: {
          id: 'Id',
          user: 'User',
          userEmail: 'User\'s e-mail',
          permission: 'Permission',
          permissionCode: 'Permission code',
        },
      },
    },
  },
}

</script>
